/* unplugin-vue-components disabled */import script from "./integration.vue?vue&type=script&lang=jsx"
export * from "./integration.vue?vue&type=script&lang=jsx"

import "./integration.vue?vue&type=style&index=0&id=8f949406&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f949406"]])

export default __exports__